var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-box",class:_vm.classes},[(_vm.icon)?_c('icon',{staticClass:"box-icon",attrs:{"name":_vm.icon.name,"theme":_vm.icon.theme,"gradient":_vm.icon.gradient}}):_vm._e(),_c('div',{staticClass:"box-content"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }